export default {
    menus() {
        return [
            {
                cn: '首页',
                en: 'Home',
                pages: [
                    { cn: '欢迎使用后台系统', en: 'Welcome', path: 'home' },
                    // { cn: 'MAP测试', en: 'MAP TEST', path: 'map' },
                ]
            }, {
                cn: '店铺（仓库）管理',
                en: 'Shop/Warehouse',
                pages: [
                    { cn: '店铺（仓库）', en: 'Shop/Warehouse', path: 'shops' },
                    { hidden: true, cn: '店铺（仓库）详情', en: 'Shop/Warehouse Detail', path: 'shop' },
                ]
            }, {
                cn: '商品管理',
                en: 'Product',
                pages: [
                    { cn: '商品分类', en: 'Type', path: 'productTypes' },
                    { hidden: true, cn: '商品分类详情', en: 'Type Detail', path: 'productType' },
                    { cn: '商品', en: 'Product', path: 'products' },
                    { hidden: true, cn: '商品详情', en: 'Product Detail', path: 'product' },
                    { hidden: true, cn: '库存历史', en: 'Inventory History', path: 'inventoryHistories' },
                ]
            }, {
                cn: '客户管理',
                en: 'Customer',
                pages: [
                    { cn: '客户', en: 'Customers', path: 'customers' },
                    { hidden: true, cn: '客户详情', en: 'Customer Detail', path: 'customer' },
                    { hidden: true, cn: '客户地址', en: 'Address', path: 'customerAddresses' },
                    { hidden: true, cn: '客户地址详情', en: 'Address Deatil', path: 'customerAddress' },

                    { cn: '代下单', en: 'Place an Order', path: 'orderAdd' },
                    { cn: '订单', en: 'Order', path: 'orders' },
                ]
            }, {
                cn: '系统管理',
                en: 'System',
                pages: [
                    // { cn: '数据字典', en: 'Dictionary', path: 'dict' },
                    { cn: '个人中心', en: 'My', path: 'my' },
                    { cn: '权限管理', en: 'Role', path: 'roleList' },
                    { hidden: true, cn: '权限详情', en: 'Role Detail', path: 'roleDetail' },
                    { cn: '后台用户', en: 'Staff', path: 'userList' },
                    { hidden: true, cn: '后台用户详情', en: 'Staff Detail', path: 'userDetail' },
                ]
            }
        ]
    },
    filter(hidden, paths) {
        const menus = this.menus()
        for (let menuIndex = menus.length - 1; menuIndex >= 0; menuIndex--) {
            const menu = menus[menuIndex]
            if (menu != null && menu.pages != null) {
                for (let pageIndex = menu.pages.length - 1; pageIndex >= 0; pageIndex--) {
                    let splice = false
                    const page = menu.pages[pageIndex]
                    if (hidden === true && !page.hidden) {
                        splice = true
                    }
                    if (hidden === false && page.hidden) {
                        splice = true
                    }
                    if (paths != null && paths.length > 0 && !paths.includes(page.path)) {
                        splice = true
                    }
                    if (splice) {
                        menu.pages.splice(pageIndex, 1)
                    }
                }
            }
            if (menu == null || menu.pages == null || menu.pages.length == 0) {
                menus.splice(menuIndex, 1)
            }
        }
        return menus
    }
}